module.exports = __webpack_public_path__ + "static/media/traversal.70f4bf07.png";